// multiplication.js - Multiplication problem generator
import { BasicProblem } from './ui.js';
import { getRandomInt } from './utils.js';

export function generateMultiplicationProblem(): BasicProblem {
    const mode = document.querySelector<HTMLInputElement>('input[name="multiplicationMode"]:checked')?.value;
    
    if (mode === 'timesTables') {
        return generateTimesTableProblem();
    } else {
        return generateNumberMultiplicationProblem();
    }
}

function generateTimesTableProblem(): BasicProblem {
    // Get all selected times tables
    const selectedTables = [...document.querySelectorAll<HTMLInputElement>('input[name="timesTable"]:checked')]
        .map(checkbox => parseInt(checkbox.value));
    
    // If no tables selected, default to 2 times table
    if (selectedTables.length === 0) {
        selectedTables.push(2);
        const timesTable2Input = document.querySelector<HTMLInputElement>('input[name="timesTable"][value="2"]');
        if (timesTable2Input) {
            timesTable2Input.checked = true;
        }
    }
    
    // Randomly select one of the chosen tables
    const table = selectedTables[Math.floor(Math.random() * selectedTables.length)];
    
    // Generate a number to multiply by (1-12)
    const multiplier = getRandomInt(1, 12);
    
    // Return the problem
    return new BasicProblem(
        String(table).padStart(4, ' '),
        String(multiplier).padStart(4, ' '),
        '×'
    );
}

function generateNumberMultiplicationProblem(): BasicProblem {
    const topDigits = parseInt((document.getElementById('topDigits') as HTMLInputElement).value) || 2;
    const bottomDigits = parseInt((document.getElementById('bottomDigits') as HTMLInputElement).value) || 1;
    
    // Generate numbers with the specified number of digits
    const min1 = Math.pow(10, topDigits - 1);
    const max1 = Math.pow(10, topDigits) - 1;
    const min2 = Math.pow(10, bottomDigits - 1);
    const max2 = Math.pow(10, bottomDigits) - 1;
    
    const top = getRandomInt(min1, max1);
    const bottom = getRandomInt(min2, max2);
    
    return new BasicProblem(
        String(top).padStart(4, ' '),
        String(bottom).padStart(4, ' '),
        '×'
    );
}